const Chapter01 = [
  {
    id: 0,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_001.jpg",
    alt: "AllSkies01_001",
  },
  {
    id: 1,
    image:
      "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_002.jpg?updatedAt=1764732642390",
    alt: "AllSkies01_002",
  },
  {
    id: 2,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_003.jpg",
    alt: "AllSkies01_003",
  },
  {
    id: 3,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_004.jpg",
    alt: "AllSkies01_004",
  },
  {
    id: 4,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_005.jpg",
    alt: "AllSkies01_005",
  },
  {
    id: 5,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_006.jpg",
    alt: "AllSkies01_006",
  },
  {
    id: 6,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_007.jpg",
    alt: "AllSkies01_007",
  },
  {
    id: 7,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_008.jpg",
    alt: "AllSkies01_008",
  },
  {
    id: 8,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_009.jpg",
    alt: "AllSkies01_009",
  },
  {
    id: 9,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_010.jpg",
    alt: "AllSkies01_010",
  },
  {
    id: 10,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_011.jpg",
    alt: "AllSkies01_011",
  },
  {
    id: 11,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_012.jpg",
    alt: "AllSkies01_012",
  },
  {
    id: 12,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_013.jpg",
    alt: "AllSkies01_013",
  },
  {
    id: 13,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_014.jpg",
    alt: "AllSkies01_014",
  },
  {
    id: 14,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_015.jpg",
    alt: "AllSkies01_015",
  },
  {
    id: 15,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_016.jpg",
    alt: "AllSkies01_016",
  },
  {
    id: 16,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_017.jpg",
    alt: "AllSkies01_017",
  },
  {
    id: 17,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_018.jpg",
    alt: "AllSkies01_018",
  },
  {
    id: 18,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_019.jpg",
    alt: "AllSkies01_019",
  },
  {
    id: 19,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_020.jpg",
    alt: "AllSkies01_020",
  },
  {
    id: 20,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_021.jpg",
    alt: "AllSkies01_021",
  },
  {
    id: 21,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_022.jpg",
    alt: "AllSkies01_022",
  },
  {
    id: 22,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_023.jpg",
    alt: "AllSkies01_023",
  },
  {
    id: 23,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_024.jpg",
    alt: "AllSkies01_024",
  },
  {
    id: 24,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_025.jpg",
    alt: "AllSkies01_025",
  },
  {
    id: 25,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_026.jpg",
    alt: "AllSkies01_026",
  },
  {
    id: 26,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_027.jpg",
    alt: "AllSkies01_027",
  },
  {
    id: 27,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_028.jpg",
    alt: "AllSkies01_028",
  },
  {
    id: 28,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_029.jpg",
    alt: "AllSkies01_029",
  },
  {
    id: 29,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_030.jpg",
    alt: "AllSkies01_030",
  },
  {
    id: 30,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_031.jpg",
    alt: "AllSkies01_031",
  },
  {
    id: 31,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_032.jpg",
    alt: "AllSkies01_032",
  },
  {
    id: 32,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_033.jpg",
    alt: "AllSkies01_033",
  },
  {
    id: 33,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_034.jpg",
    alt: "AllSkies01_034",
  },
  {
    id: 34,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_035.jpg",
    alt: "AllSkies01_035",
  },
  {
    id: 35,
    image:
      "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_036.jpg?updatedAt=1764732690274",
    alt: "AllSkies01_036",
  },
  {
    id: 36,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_037.jpg",
    alt: "AllSkies01_037",
  },
  {
    id: 37,
    image: "https://ik.imagekit.io/prismalotus/Chapter01/AllSkies01_038.jpg",
    alt: "AllSkies01_038",
  },
];

export default Chapter01;
